import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { HERO_IMAGE_URL } from '../constants/assets';

const { FiArrowDown } = FiIcons;

const HeroSection = () => {
  const scrollToJobs = () => {
    document.getElementById('job-listings')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-mag-blue text-white overflow-hidden py-24 lg:py-32">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -30 }} 
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-6xl lg:text-8xl font-black mb-8 leading-[0.9] uppercase tracking-tighter">
              Build Your <br/>Future at <span className="text-mag-green">MAG</span>
            </h1>
            <p className="text-xl lg:text-2xl mb-12 text-white/90 font-bold max-w-xl">
              Join Michigan's #1 insulation team. Professional training, top-tier equipment, and a career you can be proud of.
            </p>
            <div className="flex flex-col sm:flex-row gap-6">
              <button 
                onClick={scrollToJobs}
                className="bg-mag-green text-white px-12 py-6 rounded-2xl font-black text-xl hover:brightness-110 transition-all flex items-center justify-center space-x-4 shadow-[0_10px_40px_-10px_rgba(110,188,41,0.5)] uppercase tracking-widest"
              >
                <span>View Job Openings</span>
                <SafeIcon icon={FiArrowDown} className="w-6 h-6" />
              </button>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }} 
            animate={{ opacity: 1, scale: 1 }} 
            transition={{ duration: 0.6, delay: 0.2 }} 
            className="relative"
          >
            <div className="rounded-[3rem] overflow-hidden shadow-2xl border-8 border-white/10 ring-4 ring-mag-green">
              <img 
                src={HERO_IMAGE_URL} 
                alt="MAG Insulation Professional Work" 
                className="w-full h-[550px] object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-mag-green p-10 rounded-3xl shadow-2xl border-4 border-white transform -rotate-3">
              <div className="text-5xl font-black text-white">2,500+</div>
              <div className="text-sm font-black text-mag-black uppercase tracking-tighter">Jobs Completed and Counting</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;